import Content from '../../content.js';

namespace('IO.Views.NodeGroups', function (exports) {
  'use strict';

  var Export = Content.extend({
    dom: {
      SELECT_ALL: '#all-selected',
      SELECT_SECTION: '.section-all-select',
      CHECKBOX: '.alone-checkbox',
      BUTTON: '#select-exported-fields-btn',
    },

    events: function () {
      var events = {};

      events['change ' + this.dom.CHECKBOX] = '_checkboxChanged';
      events['change ' + this.dom.SELECT_SECTION] = '_sectionChanged';
      events['change ' + this.dom.SELECT_ALL] = '_allChanged';
      events['click ' + this.dom.BUTTON] = '_export';

      return events;
    },

    _export: function () {
      var url = '/' + currentCustomer + '/node_groups/' + nodeGroupId + '.csv';

      url +=
        '?attributes=' +
        $('.system_checkbox:checked')
          .map(function (i, el) {
            return $(el).val();
          })
          .toArray()
          .join(',');

      url +=
        '&columns=' +
        $('.dynamic_checkbox:checked')
          .map(function (i, el) {
            return $(el).val();
          })
          .toArray()
          .join(',');

      url +=
        '&columns_metadata=' +
        $('.dynamic_metadata_checkbox:checked')
          .map(function (i, el) {
            return $(el).val();
          })
          .toArray()
          .join(',');

      if (
        $('#resolve-references:checked').length === 1 &&
        $('.dynamic_checkbox:checked').length > 0
      ) {
        url += '&resolve_references=true';
      }

      location.href = url;
    },

    _allChanged: function (e) {
      $(this.dom.SELECT_SECTION)
        .prop('checked', $(e.target).is(':checked'))
        .trigger('change');
    },

    _sectionChanged: function (e) {
      var section = $(e.target).data('section'),
        checked = $(e.target).is(':checked');

      $('.' + section + '_checkbox').prop('checked', checked);
      $('.' + section + '_metadata_checkbox').prop('disabled', !checked);
      this._handleSelectAll();
    },

    _checkboxChanged: function (e) {
      this._handleSelectAll();
      this._handleSection($(e.target).data('section'));
      this._handleChild(e);
    },

    _handleSelectAll: function () {
      $(this.dom.SELECT_ALL).prop(
        'checked',
        $(this.dom.CHECKBOX).length ==
          $(this.dom.CHECKBOX + ' :checked').length,
      );
    },

    _handleSection: function (section) {
      var selector = '.' + section + '_checkbox',
        selectAll = $('.section-all-select[data-section="' + section + '"]');

      selectAll.prop(
        'checked',
        $(selector).length == $(selector + ':checked').length,
      );
    },

    _handleChild: function (e) {
      var $child = $('#' + e.target.id + '_running_version'),
        checked = $(e.target).is(':checked');

      $child
        .prop('checked', checked)
        .prop('disabled', !checked)
        .trigger('change');
    },

    render: function () {
      this._handleSection('dynamic');
      this._handleSelectAll();
    },
  });

  exports.Export = Export;
});
